import { useDashData } from "../hooks/useDashData";
import PageHeader from "../components/layout/PageHeader";
import KpiRow from "../components/dashboard/KpiRow";
import BudgetCommandCenter from "../components/dashboard/BudgetCommandCenter";
import PlatformComparison from "../components/dashboard/PlatformComparison";
import TrendCharts from "../components/dashboard/TrendCharts";

export default function Overview() {
  const { data: summary, loading } = useDashData("/analytics/summary");
  const { data: budget } = useDashData("/budgets", { withDates: false });
  const { data: comparison } = useDashData("/analytics/platform-comparison");

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader title="Performance Overview"
        subtitle="Cross-platform ROI for Hair, Skin, Laser, Surgery & Weight verticals · INR ₹" />
      <KpiRow summary={summary} loading={loading} />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2">
          <BudgetCommandCenter summary={summary} budget={budget} />
        </div>
        <div>
          <PlatformComparison comparison={comparison} />
        </div>
      </div>
      <TrendCharts />
    </div>
  );
}
